const resizeDirective = {
  beforeMount(el, binding) {
    el._resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (binding.value) {
          binding.value(entry);
        }
      }
    });

    el._resizeObserver.observe(el);
  },
  unmounted(el) {
    if (el._resizeObserver) {
      el._resizeObserver.unobserve(el);
      el._resizeObserver.disconnect();
      delete el._resizeObserver;
    }
  }
};

export default resizeDirective;
